import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CommonService } from '../../services/common.service';
import { AuthService } from '../../modules/authentication/services/auth.service';

@Component({
  selector: 'vrm-cognito-sso',
  templateUrl: './cognito-sso.component.html',
  styleUrls: ['./cognito-sso.component.scss'],
})
export class CognitoSsoComponent implements OnInit {
  ssoFailed: boolean = false;
  signInDone: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    public cService: CommonService
  ) {}

  ngOnInit() {
    console.log(':: VRM INFO: Cognito SSO Component');
    // Clear existing token in case user did not logout.
    // This ensures that the newly issued SSO Token is used.
    this.authService.quickLogout(true, () => {
      this.activatedRoute.params.subscribe({
        next: (params: { authCode: string }) => {
          if (params.authCode) {
            this.cService.showToast('Logging in...');
            this.performLoginWithCognitoAuthorizationCode(params.authCode);
          } else {
            console.error(':: VRM ERROR: Auth code cannot be empty');
            this.loginFailed();
          }
        },
      });
    });
  }

  private performLoginWithCognitoAuthorizationCode(authCode: string) {
    this.authService.cognitoSsoLogin(authCode).subscribe({
      next: (response) => {
        this.signInDone = true;
        this.authService.navigateToDefaultPage(response.startPage, this.cService.reloadAndTryToApplyUpdates);
      },
      error: () => {
        this.loginFailed();
      },
    });
  }

  private loginFailed() {
    this.ssoFailed = true;
    this.cService.showToast(':: Unable to process login');
  }
}
